<template>
    <div>
    <el-dialog
        :visible.sync="visible"
        width="30%"
        :before-close="handleClose">
        <span style="color:red">确认将此项目从我的项目中删除吗？</span>
        <div>
        <el-checkbox v-model="checked" style="margin-top: 20px;margin-bottom: 20px;">同时删除该项目下的所有文件</el-checkbox>
       </div>
        <el-button type='primary' @click="deleteData()">确认删除</el-button>
        <el-button type='primary'>取消</el-button> 
    </el-dialog>
  </div>
</template>

<script>
  export default {
    name:'DataShow',
    components:{
    },
    data() {
      return {
        activeName:'second',
        visible:false,
        data: [{
            id: 3,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }, {
            id: 2,
            label: '其他数据',
            disabled: true,
            children: [{
              id: 6,
              label: 'battery_03.csv'
            }, {
              id: 7,
              label: 'battery_04.csv',
            }]
          },
          {
            id: 10,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          },
          {
            id: 11,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }],
          data1:[{
            id: 3,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }, {
            id: 2,
            label: '其他数据',
            children: [{
              id: 6,
              label: 'battery_03.csv'
            }, {
              id: 7,
              label: 'battery_04.csv',
            }]
          },
          {
            id: 10,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          },
          {
            id: 11,
            label: '我的项目',
            children: [{
              id: 4,
              label: 'battery_01.csv'
            }, {
              id: 5,
              label: 'battery_02.csv',    
            }]
          }]
      };
    },
    created(){
      this.data1.forEach(
        item=>{
          item.children.forEach(
            it=>it.disabled='false'
          )})
    },
    props:{
        isShow:{
            type:Boolean,
            required:true,
            default:false,
        }
    },
    methods:{
      deleteData(){
        this.$confirm("删除文件后将无法恢复，是否仍要删除？", "提示", {
          confirmButtonText: "确认",
          cancelButtonText: "取消",
          type: "error",
        }).then(() => {
          this.handleClose();
          }).catch(() => {});
        },
        handleClose(){
            this.visible=false
            this.$emit('closeDeleteDialog')
        }
    },
    watch:{
        isShow:{
            handler(newVal){
                this.visible=newVal
            }
        }
    }
  };
</script>